import { Navigate, Route, Routes } from "react-router-dom";
import makeStyles from "@material-ui/styles/makeStyles";

import { candidateTableRoutes } from "../../constants";
import { CandidateTableTypes } from "../../types";

import CandidateTables from "./CandidateTables";
import Candidate from "./Candidate";


const Candidates: React.FC = () => {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Routes>
                <Route key="add" path="/add" element={<Candidate />} />
                {candidateTableRoutes.map(type => (
                    <Route
                        key={`${type}-page`}
                        path={`/${type}/:id`}
                        element={<Candidate key={`${type}-comp-page`} type={type} />}
                    />
                ))}
                {candidateTableRoutes.map(type => (
                    <Route
                        key={`${type}-table`}
                        path={`/${type}`}
                        element={<CandidateTables key={`${type}-comp-table`} type={type} />}
                    />
                ))}
                <Route path="/*" element={<Navigate to={`/candidates/${CandidateTableTypes.Approved}`} replace />} />
            </Routes>
        </div>
    );
}

export default Candidates;


const useStyles = makeStyles({
    container: {
        margin: "1rem min(2.5rem , 5vw)",
        flexGrow: 1,
        marginTop: 0,

        display: "flex",
        flexDirection: "column"
    }
});